// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"572":"b9bbc719","699":"b9bbc719"}[chunkId] + ".chunk.css";
};